

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Cookies from 'js-cookie';
// import { useNavigate } from 'react-router-dom';
// import Layout from '../components/Layout';
// import { ImageUpload } from '../api/api';
// import uploadLogo from '../assets/images/logoo.png';
// import { useDropzone } from 'react-dropzone';

// function DashboardHome({ categories }) {
//   const [files, setFiles] = useState([]); // Store multiple files
//   const [name, setName] = useState('');
//   const [category, setCategory] = useState('Popular');
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState('');
//   const [imagePreviews, setImagePreviews] = useState([]); // Store multiple image previews
//   const [error, setError] = useState('');

//   const navigate = useNavigate();
//   const username = Cookies.get('username');

//   const checkuser = () => {
//     if (!username) {
//       navigate('/login');
//     }
//   };

//   useEffect(() => {
//     checkuser();
//   }, []);

//   const onNameChange = (e) => {
//     setName(e.target.value);
//   };

//   const onCategoryChange = (e) => {
//     setCategory(e.target.value);
//   };

//   const onDrop = (acceptedFiles) => {
//     const validFiles = acceptedFiles.filter(file => 
//       file.type === 'image/jpeg' || file.type === 'image/jpg'
//     );

//     if (validFiles.length < acceptedFiles.length) {
//       setError('Only .jpeg or .jpg images are allowed.');
//     } else {
//       setError('');
//     }

//     setFiles([...files, ...validFiles]);

//     const newPreviews = validFiles.map(file => {
//       const reader = new FileReader();
//       return new Promise((resolve) => {
//         reader.onloadend = () => {
//           resolve(reader.result);
//         };
//         reader.readAsDataURL(file);
//       });
//     });

//     Promise.all(newPreviews).then(previews => {
//       setImagePreviews([...imagePreviews, ...previews]);
//     });
//   };

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: '.jpeg, .jpg',
//   });

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const formData = new FormData();
// files.forEach((file) => {
//   formData.append('files', file); // Use 'files' as the field name for all files
// });
// formData.append('name', name);
// formData.append('category', category);

// try {
//   const response = await axios.post(ImageUpload, formData, {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//   });
//   setMessage(response.data.message);
//   toast.success('Uploaded successfully');
//   setFiles([]);
//   setImagePreviews([]);
// } catch (error) {
//   setMessage('Error uploading images');
//   toast.error('Error uploading images');
// } finally {
//   setLoading(false);
//   setName('');
// }
//   }

//   return (
//     <Layout>
//       <ToastContainer />
//       <div className="flex justify-center lg:ml-64">
//         <div className="w-[320px] lg:w-[400px] mx-auto mt-4 p-6 border border-gray-200 bg-white rounded-lg shadow-lg">
//           <h1 className="text-2xl font-bold mb-4">Upload Images</h1>
//           <h1 className='text-center text-gray-500'>Multiple Images Upload Limit 10</h1>
//           <form onSubmit={onSubmit} className="space-y-4">
//             <div {...getRootProps()} className="border-dashed border-2 border-gray-300 p-4 rounded-lg cursor-pointer">
//               <input {...getInputProps()} />
//               {isDragActive ? (
//                 <p className="text-center text-gray-600">Drop the files here ...</p>
//               ) : (
//                 <div className="flex flex-col items-center mx-2 overflow-hidden">
//                   <img src={uploadLogo} alt="upload" className='h-[60px]' />
//                   <p className="text-center text-gray-600 mt-2">
//                     {files.length > 0 ? `Selected files: ${files.map(f => f.name).join(', ')}` : 'Drag and drop images here, or click to select files'}
//                   </p>
//                 </div>
//               )}
//             </div>
            
//             {error && (
//               <div className="mt-2 text-center text-red-500">
//                 <p>{error}</p>
//               </div>
//             )}

//             {imagePreviews.length > 0 && (
//               <div className="mt-4 grid grid-cols-2 gap-2">
//                 {imagePreviews.map((preview, index) => (
//                   <img key={index} src={preview} alt={`Preview ${index}`} className="w-full h-24 object-cover rounded" />
//                 ))}
//               </div>
//             )}
            
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Name</label>
//               <input
//                 type="text"
//                 value={name}
//                 onChange={onNameChange}
//                 placeholder="Enter Image Title"
//                 className="mt-1 block w-full py-2 px-2 text-gray-900 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//                 required
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700">Category</label>
//               <select onChange={onCategoryChange} value={category}
//                className="mt-1 block w-full py-2 px-2 text-gray-900 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               >
//               {categories.map((category, index) => (
//                 <option key={index} value={category}>
//                   {category}
//                 </option>
//               ))}
//             </select>
//             </div>
            
//           <div className='flex justify-center items-center'>
//           <button
//               type="submit"
//               className="w-[180px] bg-indigo-600 text-white py-2 px-4 rounded-lg focus:ring-4 focus:ring-indigo-300"
//               disabled={loading}
//             >
//               {loading ? 'Uploading...' : 'Upload'}
//             </button>
//           </div>
          
//           </form>
//           {message && (
//             <div className="mt-4 text-sm flex justify-center items-center">
//               <p className='text-green-600'>{message}</p>
//             </div>
//           )}
//         </div>
//       </div>
//     </Layout>
//   );
// }

// export default DashboardHome;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Cookies from 'js-cookie';
// import { useNavigate } from 'react-router-dom';
// import Layout from '../components/Layout';
// import { ImageUpload } from '../api/api';
// import uploadLogo from '../assets/images/logoo.png';
// import { useDropzone } from 'react-dropzone';

// function DashboardHome({ categories }) {
//   const [files, setFiles] = useState([]); // Store multiple files
//   const [name, setName] = useState('');
//   const [category, setCategory] = useState('Popular');
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState('');
//   const [error, setError] = useState('');

//   const navigate = useNavigate();
//   const username = Cookies.get('username');

//   const checkuser = () => {
//     if (!username) {
//       navigate('/login');
//     }
//   };

//   useEffect(() => {
//     checkuser();
//   }, []);

//   const onNameChange = (e) => {
//     setName(e.target.value);
//   };

//   const onCategoryChange = (e) => {
//     setCategory(e.target.value);
//   };

//   const onDrop = (acceptedFiles) => {
//     const validFiles = acceptedFiles.filter(file =>
//       file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'video/mp4'
//     );

//     if (validFiles.length < acceptedFiles.length) {
//       setError('Only .jpeg, .jpg, or .mp4 files are allowed.');
//     } else {
//       setError('');
//     }

//     setFiles([...files, ...validFiles]);
//   };

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: {
//       'image/jpeg': ['.jpeg', '.jpg'],
//       'video/mp4': ['.mp4'],
//     },
//   });

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const formData = new FormData();
//     files.forEach((file) => {
//       formData.append('files', file);
//     });
//     formData.append('name', name);
//     formData.append('category', category);

//     try {
//       const response = await axios.post(ImageUpload, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       setMessage(response.data.message);
//       toast.success('Uploaded successfully');
//       setFiles([]);
//     } catch (error) {
//       setMessage('Error uploading files');
//       toast.error('Error uploading files');
//     } finally {
//       setLoading(false);
//       setName('');
//     }
//   };

//   return (
//     <Layout>
//       <ToastContainer />
//       <div className="flex justify-center lg:ml-64">
//         <div className="w-[320px] lg:w-[400px] mx-auto mt-4 p-6 border border-gray-200 bg-white rounded-lg shadow-lg">
//           <h1 className="text-2xl font-bold mb-4">Upload Media</h1>
//           <h1 className="text-center text-gray-500">Upload .jpg, .jpeg or .mp4</h1>
//           <form onSubmit={onSubmit} className="space-y-4">
//             <div {...getRootProps()} className="border-dashed border-2 border-gray-300 p-4 rounded-lg cursor-pointer">
//               <input {...getInputProps()} />
//               {isDragActive ? (
//                 <p className="text-center text-gray-600">Drop the files here ...</p>
//               ) : (
//                 <div className="flex flex-col items-center mx-2 overflow-hidden">
//                   <img src={uploadLogo} alt="upload" className="h-[100px]" />
//                   <p className="text-center text-gray-600 mt-2">
//                     {files.length > 0
//                       ? `Selected files: ${files.map(f => f.name).join(', ')}`
//                       : 'Drag and drop files here, or click to select'}
//                   </p>
//                 </div>
//               )}
//             </div>

//             {error && (
//               <div className="mt-2 text-center text-red-500">
//                 <p>{error}</p>
//               </div>
//             )}

//             {files.length > 0 && (
//               <div className="mt-4 grid grid-cols-2 gap-2">
//                 {files.map((file, i) => {
//                   const fileURL = URL.createObjectURL(file);
//                   const isVideo = file.type.startsWith('video');

//                   return (
//                     <div key={i} className="relative border rounded overflow-hidden">
//                       {isVideo ? (
//                         <video
//                           src={fileURL}
//                           controls
//                           className="w-full h-32  object-contain"
//                         />
//                       ) : (
//                         <img
//                           src={fileURL}
//                           alt={`Preview ${i}`}
//                           className="w-full h-32 object-cover"
//                         />
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             )}

//             <div>
//               <label className="block text-sm font-medium text-gray-700">Name</label>
//               <input
//                 type="text"
//                 value={name}
//                 onChange={onNameChange}
//                 placeholder="Enter Title"
//                 className="mt-1 block w-full py-2 px-2 text-gray-900 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//                 required
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700">Category</label>
//               <select
//                 onChange={onCategoryChange}
//                 value={category}
//                 className="mt-1 block w-full py-2 px-2 text-gray-900 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               >
//                 {categories.map((category, index) => (
//                   <option key={index} value={category}>
//                     {category}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="flex justify-center items-center">
//               <button
//                 type="submit"
//                 className="w-[180px] bg-indigo-600 text-white py-2 px-4 rounded-lg focus:ring-4 focus:ring-indigo-300"
//                 disabled={loading}
//               >
//                 {loading ? 'Uploading...' : 'Upload'}
//               </button>
//             </div>
//           </form>

//           {message && (
//             <div className="mt-4 text-sm flex justify-center items-center">
//               <p className="text-green-600">{message}</p>
//             </div>
//           )}
//         </div>
//       </div>
//     </Layout>
//   );
// }

// export default DashboardHome;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Cookies from 'js-cookie';
// import { useNavigate } from 'react-router-dom';
// import Layout from '../components/Layout';
// import { ImageUpload } from '../api/api';
// import uploadLogo from '../assets/images/logoo.png';
// import { useDropzone } from 'react-dropzone';

// function DashboardHome({ categories }) {
//   const [files, setFiles] = useState([]); // Store multiple files
//   const [name, setName] = useState('');
//   const [category, setCategory] = useState('Popular');
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState('');
//   const [error, setError] = useState('');

//   const navigate = useNavigate();
//   const username = Cookies.get('username');

//   const checkuser = () => {
//     if (!username) {
//       navigate('/login');
//     }
//   };

//   useEffect(() => {
//     checkuser();
//   }, []);

//   const onNameChange = (e) => {
//     setName(e.target.value);
//   };

//   const onCategoryChange = (e) => {
//     setCategory(e.target.value);
//   };

//   const onDrop = (acceptedFiles) => {
//     const validFiles = acceptedFiles.filter(file =>
//       file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'video/mp4'
//     );

//     if (validFiles.length < acceptedFiles.length) {
//       setError('Only .jpeg, .jpg, or .mp4 files are allowed.');
//       return;
//     }

//     if (files.length + validFiles.length > 10) {
//       setError('You can only upload a maximum of 10 files.');
//       return;
//     }

//     setError('');
//     setFiles([...files, ...validFiles]);
//   };

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: {
//       'image/jpeg': ['.jpeg', '.jpg'],
//       'video/mp4': ['.mp4'],
//     },
//   });

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     if (files.length === 0) {
//       setError('Please select at least one file to upload.');
//       setLoading(false);
//       return;
//     }

//     const formData = new FormData();
//     files.forEach((file) => {
//       formData.append('files', file);
//     });
//     formData.append('name', name);
//     formData.append('category', category);

//     try {
//       const response = await axios.post(ImageUpload, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       setMessage(response.data.message);
//       toast.success('Uploaded successfully');
//       setFiles([]);
//     } catch (error) {
//       setMessage('Error uploading files');
//       toast.error('Error uploading files');
//     } finally {
//       setLoading(false);
//       setName('');
//     }
//   };

//   return (
//     <Layout>
//       <ToastContainer />
//       <div className="flex justify-center lg:ml-64">
//         <div className="w-[320px] lg:w-[400px] mx-auto mt-4 p-6 border border-gray-200 bg-white rounded-lg shadow-lg">
//           <h1 className="text-2xl font-bold mb-4">Upload Media</h1>
//           <h1 className="text-center text-gray-500">Upload .jpg, .jpeg or .mp4 (max 10 files)</h1>
//           <form onSubmit={onSubmit} className="space-y-4">
//             <div {...getRootProps()} className="border-dashed border-2 border-gray-300 p-4 rounded-lg cursor-pointer">
//               <input {...getInputProps()} multiple />
//               {isDragActive ? (
//                 <p className="text-center text-gray-600">Drop the files here ...</p>
//               ) : (
//                 <div className="flex flex-col items-center mx-2 overflow-hidden">
//                   <img src={uploadLogo} alt="upload" className="h-[100px]" />
//                   <p className="text-center text-gray-600 mt-2">
//                     {files.length > 0
//                       ? `Selected files (${files.length}): ${files.map(f => f.name).join(', ')}`
//                       : 'Drag and drop files here, or click to select'}
//                   </p>
//                 </div>
//               )}
//             </div>

//             {error && (
//               <div className="mt-2 text-center text-red-500">
//                 <p>{error}</p>
//               </div>
//             )}

//             {files.length > 0 && (
//               <div className="mt-4 grid grid-cols-2 gap-2">
//                 {files.map((file, i) => {
//                   const fileURL = URL.createObjectURL(file);
//                   const isVideo = file.type.startsWith('video');

//                   return (
//                     <div key={i} className="relative border rounded overflow-hidden">
//                       {isVideo ? (
//                         <video
//                           src={fileURL}
//                           controls
//                           className="w-full h-32 object-contain"
//                         />
//                       ) : (
//                         <img
//                           src={fileURL}
//                           alt={`Preview ${i}`}
//                           className="w-full h-32 object-cover"
//                         />
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             )}

//             <div>
//               <label className="block text-sm font-medium text-gray-700">Name</label>
//               <input
//                 type="text"
//                 value={name}
//                 onChange={onNameChange}
//                 placeholder="Enter Title"
//                 className="mt-1 block w-full py-2 px-2 text-gray-900 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//                 required
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700">Category</label>
//               <select
//                 onChange={onCategoryChange}
//                 value={category}
//                 className="mt-1 block w-full py-2 px-2 text-gray-900 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               >
//                 {categories.map((category, index) => (
//                   <option key={index} value={category}>
//                     {category}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="flex justify-center items-center">
//               <button
//                 type="submit"
//                 className="w-[180px] bg-indigo-600 text-white py-2 px-4 rounded-lg focus:ring-4 focus:ring-indigo-300"
//                 disabled={loading}
//               >
//                 {loading ? 'Uploading...' : 'Upload'}
//               </button>
//             </div>
//           </form>

//           {message && (
//             <div className="mt-4 text-sm flex justify-center items-center">
//               <p className="text-green-600">{message}</p>
//             </div>
//           )}
//         </div>
//       </div>
//     </Layout>
//   );
// }

// export default DashboardHome;



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { ImageUpload } from '../api/api';
import uploadLogo from '../assets/images/logoo.png';
import { useDropzone } from 'react-dropzone';

function DashboardHome({ categories }) {
  const [files, setFiles] = useState([]); // Store multiple files
  const [fileURLs, setFileURLs] = useState([]); // Store preview URLs
  const [name, setName] = useState('');
  const [category, setCategory] = useState('Popular');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();
  const username = Cookies.get('username');

  const checkuser = () => {
    if (!username) {
      navigate('/login');
    }
  };

  useEffect(() => {
    checkuser();
  }, []);

  // Create preview URLs only when files change
  useEffect(() => {
    if (files.length === 0) {
      setFileURLs([]);
      return;
    }

    const urls = files.map(file => URL.createObjectURL(file));
    setFileURLs(urls);

    // Cleanup: revoke URLs when files change or component unmounts
    return () => {
      urls.forEach(url => URL.revokeObjectURL(url));
    };
  }, [files]);

  const onNameChange = (e) => {
    setName(e.target.value);
  };

  const onCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  const onDrop = (acceptedFiles) => {
    const validFiles = acceptedFiles.filter(file =>
      file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'video/mp4'
    );

    if (validFiles.length < acceptedFiles.length) {
      setError('Only .jpeg, .jpg, or .mp4 files are allowed.');
      return;
    }

    if (files.length + validFiles.length > 10) {
      setError('You can only upload a maximum of 10 files.');
      return;
    }

    setError('');
    setFiles([...files, ...validFiles]);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpeg', '.jpg'],
      'video/mp4': ['.mp4'],
    },
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (files.length === 0) {
      setError('Please select at least one file to upload.');
      setLoading(false);
      return;
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    formData.append('name', name);
    formData.append('category', category);

    try {
      const response = await axios.post(ImageUpload, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage(response.data.message);
      toast.success('Uploaded successfully');
      setFiles([]);
      setFileURLs([]); // clear previews after successful upload
    } catch (error) {
      setMessage('Error uploading files');
      toast.error('Error uploading files');
    } finally {
      setLoading(false);
      setName('');
    }
  };

  return (
    <Layout>
      <ToastContainer />
      <div className="flex justify-center lg:ml-64">
        <div className="w-[320px] lg:w-[400px] mx-auto mt-4 p-6 border border-gray-200 bg-white rounded-lg shadow-lg">
          <h1 className="text-2xl font-bold mb-4">Upload Media</h1>
          <h1 className="text-center text-gray-500">Upload .jpg, .jpeg or .mp4 (max 10 files)</h1>
          <form onSubmit={onSubmit} className="space-y-4">
            <div {...getRootProps()} className="border-dashed border-2 border-gray-300 p-4 rounded-lg cursor-pointer">
              <input {...getInputProps()} multiple />
              {isDragActive ? (
                <p className="text-center text-gray-600">Drop the files here ...</p>
              ) : (
                <div className="flex flex-col items-center mx-2 overflow-hidden">
                  <img src={uploadLogo} alt="upload" className="h-[100px]" />
                  <p className="text-center text-gray-600 mt-2">
                    {files.length > 0
                      ? `Selected files (${files.length}): ${files.map(f => f.name).join(', ')}`
                      : 'Drag and drop files here, or click to select'}
                  </p>
                </div>
              )}
            </div>

            {error && (
              <div className="mt-2 text-center text-red-500">
                <p>{error}</p>
              </div>
            )}

            {files.length > 0 && (
              <div className="mt-4 grid grid-cols-2 gap-2">
                {files.map((file, i) => {
                  const fileURL = fileURLs[i]; // use stored URL
                  const isVideo = file.type.startsWith('video');

                  return (
                    <div key={i} className="relative border rounded overflow-hidden">
                      {isVideo ? (
                        <video
                          src={fileURL}
                          controls
                          className="w-full h-32 object-contain"
                        />
                      ) : (
                        <img
                          src={fileURL}
                          alt={`Preview ${i}`}
                          className="w-full h-32 object-cover"
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700">Name</label>
              <input
                type="text"
                value={name}
                onChange={onNameChange}
                placeholder="Enter Title"
                className="mt-1 block w-full py-2 px-2 text-gray-900 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Category</label>
              <select
                onChange={onCategoryChange}
                value={category}
                className="mt-1 block w-full py-2 px-2 text-gray-900 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              >
                {categories.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex justify-center items-center">
              <button
                type="submit"
                className="w-[180px] bg-indigo-600 text-white py-2 px-4 rounded-lg focus:ring-4 focus:ring-indigo-300"
                disabled={loading}
              >
                {loading ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          </form>

          {message && (
            <div className="mt-4 text-sm flex justify-center items-center">
              <p className="text-green-600">{message}</p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default DashboardHome;
